module.exports = __webpack_public_path__ + "img/red_033.77457e9c.png";